import React from 'react';
//MUI Components
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import SelectInput from './../../common/SelectInput';
import TextField from '@mui/material/TextField';
//Constants
import {
	bloodGroupOptions,
	foodHabitsOptions,
	drinkingHabitsOptions,
	smokingHabitsOptions
} from './../../constants/profileData';

function OtherDetails({
	bloodGroup,
	height,
	weight,
	foodHabits,
	drinkHabits,
	smokingHabits,
	handleChange,
	data,
}) {
	return (
		<div>
			<center>
				<h3 className='profile-header'>
					<Typography variant='h6' gutterBottom>
						Other Details
					</Typography>
				</h3>
			</center>
			<React.Fragment>
				<Grid container spacing={3}>
					{/* Blood Group */}
					<Grid item xs={12} sm={6}>
						<SelectInput
							name='bloodGroup'
							label='Blood Group'
							value={bloodGroup}
							handleChange={handleChange}
							options={bloodGroupOptions}
						/>
					</Grid>
					{/* Height */}
					<Grid item xs={12} sm={6}>
						<TextField
							name='height'
							label='Height(in cm)'
							error={data['height'].error}
							helperText={
								data['height'].error
									? data['height'].helperText
									: ''
							}
							value={height}
							type='number'
							variant='standard'
							placeholder='Height in cm'
							onChange={handleChange}
							fullWidth
						/>
					</Grid>
					{/* Weight */}
					<Grid item xs={12} sm={6}>
						<TextField
							name='weight'
							label='Weight'
							error={data['weight'].error}
							helperText={
								data['weight'].error
									? data['weight'].helperText
									: ''
							}
							value={weight}
							type='number'
							variant='standard'
							placeholder='Weight in kg'
							onChange={handleChange}
							fullWidth
						/>
					</Grid>
					{/* Food Habits */}
					<Grid item xs={12} sm={6}>
						<SelectInput
							name='foodHabits'
							label='Food Habits'
							value={foodHabits}
							handleChange={handleChange}
							options={foodHabitsOptions}
						/>
					</Grid>
					{/* Drinking Habits */}
					<Grid item xs={12} sm={6}>
						<SelectInput
							name='drinkingHabits'
							label='Drinking Habits'
							value={drinkHabits}
							handleChange={handleChange}
							options={drinkingHabitsOptions}
						/>
					</Grid>
					{/* Smoking Habits */}
					<Grid item xs={12} sm={6}>						
						<SelectInput
							name='smokingHabits'
							label='Smoking Habits'
							value={smokingHabits}
							handleChange={handleChange}
							options={smokingHabitsOptions}
						/>
					</Grid>
				</Grid>
			</React.Fragment>
		</div>
	);
}

export default OtherDetails;
